// @ts-nocheck
import React from "react";

// This is a simplified Figma-inspired component for pinning to dashboard modal.
// It includes options to select existing tabs or create a new tab.

const PinToDashboardModal = () => {
  return (
    <div className="flex-1 bg-slate-100/70 px-6 py-8">
      <div className="mx-auto max-w-[900px]">
        <div className="rounded-2xl border border-slate-200 bg-white shadow-xl">
          <div className="flex items-center justify-between px-6 py-5">
            <h2 className="text-lg font-semibold text-slate-900">Pin to Dashboard</h2>
            <button className="rounded-full p-1 text-slate-400 hover:text-slate-600">
              <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M6 6l12 12M18 6l-12 12" />
              </svg>
            </button>
          </div>

          <div className="border-t border-slate-200 px-6 py-6">
            <div className="space-y-6">
              <div>
                <label className="text-sm font-medium text-slate-700">Choose a tab</label>
                <div className="mt-2 flex items-center justify-between rounded-lg bg-slate-100 px-4 py-2 text-sm text-slate-500">
                  <span>Select an existing tab</span>
                  <svg viewBox="0 0 20 20" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 7l5 5 5-5" />
                  </svg>
                </div>
              </div>

              <div>
                <label className="text-sm font-medium text-slate-700">Create a new tab</label>
                <div className="mt-2 rounded-lg bg-slate-100 px-4 py-2 text-sm text-slate-500">
                  Name your tab
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-end border-t border-slate-200 px-6 py-5">
            <button className="flex items-center gap-2 rounded-lg bg-slate-600 px-6 py-2 text-sm font-semibold text-white shadow">
              <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2l3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1 3-6z" />
              </svg>
              Pin
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PinToDashboardModal;
